<template>
    <div class="m_container" :class="{ noscroll: showMessage && token }">
        <Header :title="title" />
        <section class="m_section">
            <div class="content_wrap">
                <div v-if="showMember && token" class="memberWrap">
                    <MemberInfo
                        :tid="tid"
                        :rule="language === 'en' ? memberSettingEn : memberSetting"
                        :save-loading="saveLoading"
                        :froms="froms"
                        @showMember="handleChangeForm"
                        @submit="submitMember"
                    />
                </div>
                <div v-if="!showMember && token" class="zuopinWrap">
                    <ZuopinInfo
                        ref="zuopin"
                        :tid="tid"
                        :zpid="Number(zpid)"
                        :rule="language === 'en' ? zuopinSettingEn : zuopinSetting"
                        :froms="froms"
                        @submit="submitZuopin"
                    />
                </div>
            </div>
        </section>

        <TabBar :current-tab="currentTab" />

        <!-- 协议 弹窗 -->
        <Agreement v-if="showMessage && token" :visible="showMessage" :agreement="agreement" :status="agree" @clickAgree="handleAgree" />
    </div>
</template>

<script>
import Header from '@/components/Header/index'
import TabBar from '@/components/TabBar/index'
import EventBus from '@/utils/eventBus'
import { getToken, getTid, setTid, getAgreement, setAgreement } from '@/utils/cookies'
import { saveMember, editMember, addZuopin, editZuopin } from '@/api/Tougaos'
import { mapGetters } from 'vuex'
import MemberInfo from './component/memberInfo'
import ZuopinInfo from './component/zuopinInfo'
import Agreement from './component/agreement.vue'
import mixin from './mixin'

export default {
    name: 'TouGao',
    components: { Header, TabBar, MemberInfo, ZuopinInfo, Agreement },
    mixins: [mixin],
    data() {
        return {
            language: this.$store.getters.language,
            froms: '',
            member_id: 0,
            tid: this.$route.query.tid ? this.$route.query.tid : getTid(),
            zpid: this.$route.query.zpid,
            title: this.$store.getters.language === 'en' ? 'Basic Information' : '基本信息',
            currentTab: 'tougao',
            showMember: true, // 基本信息、作品信息切换
            saveLoading: false,
            agree: false,
            showMessage: false // 弹窗 需知
        }
    },

    computed: {
        ...mapGetters(['tougaoInfo', 'tougaoSetting', 'memberSetting', 'memberSettingEn', 'zuopinSetting', 'zuopinSettingEn']),
        agreement() {
            const { language, tougaoSetting } = this
            return language === 'en' ? tougaoSetting.agreement_en : tougaoSetting.agreement
        }
    },

    beforeRouteEnter: (to, from, next) => {
        next((vm) => {
            if (!getToken()) {
                vm.toLogin()
            }
            vm.froms = to.query.isEdit ? from.path : ''
        })
    },

    created() {
        this.tid ? setTid(this.tid) : ''
    },

    mounted() {
        EventBus.$on('member_id', (res) => {
            // 接收兄弟组件的值
            res ? (this.member_id = res) : ''
        })
        if (new Date() > new Date(this.tougaoInfo.end_at)) {
            this.$alert(this.$t('Notification.errorTouGao'), this.$t('Notification.tip'), {
                confirmButtonText: this.$t('Notification.sure')
            })
            return
        }

        // #region 协议处理
        const isAgree = getAgreement()
        if (!isAgree) {
            this.agreement && this.agreement.length > 0 ? (this.showMessage = true) : (this.showMessage = false)
        }
        // #endregion
    },

    methods: {
        handleAgree() {
            this.agree = !this.agree
            if (this.agree) {
                this.showMessage = false
                setAgreement(1)
            }
        },

        toLogin() {
            this.$alert(this.$t('Notification.login_tip'), this.$t('Notification.tip'), {
                confirmButtonText: this.$t('Notification.sure'),
                callback: (action) => {
                    this.$router.push({ path: '/login', query: { tid: this.tid } })
                }
            })
        },

        handleChangeForm(bool) {
            const title = this.language === 'en' ? 'Work Information' : '作品信息'
            !bool ? (this.title = title) : ''
            this.showMember = bool
        },

        submitMember(data) {
            console.log('submit - Member', data)
            const API = data.id ? editMember : saveMember
            this.saveLoading = true
            API(data)
                .then((res) => {
                    if (res.code === 200) {
                        this.handleChangeForm(false)
                        this.member_id = res.data.id
                    }
                    this.saveLoading = false
                    window.scrollTo(0, 0)
                })
                .catch(() => {
                    this.saveLoading = false
                })
        },

        submitZuopin(data) {
            console.log('submit - zuopin', data, this.member_id)
            this.$set(data, 'member_id', this.member_id)
            const API = data.id ? editZuopin : addZuopin
            this.saveLoading = true
            API(data).then((res) => {
                if (res.code === 200) {
                    this.$notify({
                        title: this.$t('Notification.suc_title'),
                        message: this.$t('Notification.suc_submit'),
                        type: 'success',
                        duration: 2000
                    })
                    this.$router.push({ path: '/my', query: { tid: this.tid } })
                }
                this.saveLoading = false
            })
        }
    }
}
</script>

<style lang="less" scoped>
.noscroll {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}
.m_container {
    width: 100%;
    height: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: #f5f5f5;

    .m_section {
        flex: 1;

        .content_wrap {
            margin: 0;
            background: #fff;
        }

        .submitbtn {
            width: 90%;
        }
    }
}
/deep/ .el-dialog__body {
    padding: 0 20px 20px;
}
.agree-wrap {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    .agr-img {
        width: 14px;
        height: 14px;
    }
    .agr-wrods {
        font-size: 14px;
        color: #000;
        margin-left: 6px;
    }
}
</style>
